export const environment = {
  baseURL: 'https://preprodiam.bakerripley.org/api/v1',
  clientId: 'd4545c94-1ebf-42e2-a215-0f67974bb729',
  authority: "https://login.microsoftonline.com/d02faac5-2957-4cd1-94db-7709baec2bb0",
  redirectUri: 'https://preprodiam.bakerripley.org/',
  postLogoutRedirectURI: 'https://preprodiam.bakerripley.org/',
  buildNumber: '20240212.1'
};
